// extracted by mini-css-extract-plugin
module.exports = {"headerText":"GroupHeader_headerText__3OKhi","headerIcon":"GroupHeader_headerIcon__2-e0N"};